import script from "./addMedic.vue?vue&type=script&setup=true&lang=ts"
export * from "./addMedic.vue?vue&type=script&setup=true&lang=ts"

import "./addMedic.vue?vue&type=style&index=0&id=194e9ef8&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194e9ef8"]])

export default __exports__